import { ReactNode, useEffect, useState } from "react";
import { CustomStateHook } from "../../Hooks/State.hook";
import { ModalBasis } from "../ModalBasis";
import Input from "../Input";
import { defaultInput50, defaultSelect100 } from "../../components-variants/defaultInputs";
import Select from "../Select";
import { toast } from "react-toastify";
import { currentRoute } from "../../contexts/global/LoginContext";

interface ExportChatDialogProps {
	modalState: CustomStateHook<ReactNode>;
	contactId: number;
	attendanceId: number;
}

export const ExportChatDialog = ({ modalState, contactId, attendanceId }: ExportChatDialogProps) => {
	const [exportMethod, setExportMethod] = useState<string | null>(null);
	const [fileType, setFileType] = useState<string | null>(null);

	const [rangeDate, setRangeDate] = useState<{ firstDate: string | undefined; secondDate: string | undefined }>({
		firstDate: undefined,
		secondDate: undefined,
	});
	const [url, setUrl] = useState<string>("");

	useEffect(() => {
		const baseURL = process.env.REACT_APP_API_URL
			? `${process.env.REACT_APP_API_URL}/${currentRoute}`
			: `http://localhost:8000/api/${currentRoute}`;

		let URL = `${baseURL}/messages/export/${contactId}`;

		if (exportMethod === "period") {
			URL += `?filterType=${exportMethod}&dateRange=${rangeDate.firstDate}_${rangeDate.secondDate}`;
		}
		if (exportMethod === "atendance") {
			URL += `?filterType=${exportMethod}&attendanceId=${attendanceId}`;
		}
		if (exportMethod === "all") {
			URL += `?filterType=${exportMethod}`;
		}
		if (fileType) {
			URL += `&fileType=${fileType}`;
		}

		setUrl(URL);
	}, [exportMethod, rangeDate, contactId, attendanceId, fileType]);

	const heightToDisplay = exportMethod === "period" ? 16 : 14;

	const disabled =
		!fileType ||
		!exportMethod ||
		(exportMethod === "period" &&
			(!rangeDate.firstDate ||
				!rangeDate.secondDate ||
				new Date(rangeDate.firstDate) >= new Date(rangeDate.secondDate)));

	return (
		<ModalBasis
			title="Exportar conversa"
			padding={{ v: 1, h: 1 }}
			size={{ h: heightToDisplay }}
			onClose={() => modalState.reset()}
		>
			<Select
				{...defaultSelect100}
				$fontSize={1}
				placeholder="Método de exportação"
				options={[
					{ name: "Todas mensagens", value: "all" },
					{ name: "Todas mensagens do atendimento", value: "atendance" },
					{ name: "Todas mensagens do período", value: "period" },
				]}
				onChange={(e) => setExportMethod(e)}
				className="export-chat-select"
			/>

			{exportMethod === "period" && (
				<div style={{ display: "flex", gap: "1rem" }}>
					<Input
						{...defaultInput50}
						type="date"
						onChange={(e) => setRangeDate((prev) => ({ ...prev, firstDate: e.target.valueAsNumber.toString() }))}
					/>
					<Input
						{...defaultInput50}
						type="date"
						onChange={(e) => setRangeDate((prev) => ({ ...prev, secondDate: e.target.valueAsNumber.toString() }))}
					/>
				</div>
			)}

			<Select
				{...defaultSelect100}
				$fontSize={1}
				placeholder="Arquivo de exportação"
				options={[
					{ name: "PDF", value: "pdf" },
					{ name: "TXT", value: "txt" },
				]}
				onChange={(e) => setFileType(e)}
				className="export-chat-select"
			/>

			<a
				className="hrefButton"
				onClick={(e) => {
					if (disabled) {
						e.preventDefault();
						toast.error("Preencha todos os campos corretamente");
					}
				}}
				href={!disabled ? url : "."}
				target="_blank"
				style={{ padding: "0.625rem 2rem", fontSize: "1rem", marginTop: "1rem", alignSelf: "center" }}
				rel="noreferrer"
			>
				Exportar
			</a>
		</ModalBasis>
	);
};
